// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* background-color: #f8fafb; */
  /* background-color: #f7f7f7; */
  background-color: #ffff;
}
:root {
  --tw-scrollbar-thumb-color: rgb(
    208,
    208,
    208
  ); /* Set your preferred color for the scrollbar thumb */
  /* --tw-scrollbar-track-color: blue; Set your preferred color for the scrollbar track */
}
/* Custom scrollbar styling for Webkit browsers (Chrome, Safari) */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: var(--tw-scrollbar-thumb-color);
  border-radius: 4px;
}

::-webkit-scrollbar-track {
  background-color: var(--tw-scrollbar-track-color);
}

/* Custom scrollbar styling for Firefox */
.scrollbar-thin {
  scrollbar-color: var(--tw-scrollbar-thumb-color)
    var(--tw-scrollbar-track-color);
}

.scrollbar-thumb-gray-500 {
  background-color: var(--tw-scrollbar-thumb-color);
}

.scrollbar-track-gray-200 {
  background-color: var(--tw-scrollbar-track-color);
}

/* Set scrollbar width for Firefox */
.scrollbar-thin {
  scrollbar-width: thin;
}

/* For webkit browsers (Chrome, Safari) */
.primary-scroll::-webkit-scrollbar {
  width: 1px; /* Adjust the width as needed */
}

.primary-scroll::-webkit-scrollbar-thumb {
  background-color: var(--tw-scrollbar-track-color); /* Scroll thumb color */
  border-radius: 5px;
}

.primary-scroll::-webkit-scrollbar-track {
  background-color: rgba(
    29,
    78,
    216,
    0.1
  ); /* Scroll track color with opacity */
  border-radius: 5px;
  margin: auto;
  max-height: 50%;
}

/* For Firefox */
.primary-scroll {
  scrollbar-width: thin;
  scrollbar-color: var(--tw-scrollbar-track-color) rgba(29, 78, 216, 0.1);
}

/* For IE and Edge */
.primary-scroll {
  -ms-overflow-style: none;
  scrollbar-width: thin;
  scrollbar-color: var(--tw-scrollbar-track-color) rgba(29, 78, 216, 0.1);
}

.stepper-cards {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 895px;
  border-radius: 0.75rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(231 236 244 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding: 2.5rem;
  --tw-shadow: 0px 1px 9px 0px rgba(0,0,0,0.11);
  --tw-shadow-colored: 0px 1px 9px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.white-bg-btn {
  display: flex;
  height: 2.75rem;
  width: 168.5px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(150 150 150 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  font-weight: 600;
  font-style: normal;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(119 85 61 / var(--tw-text-opacity));
}

.brown-bg-btn {
  display: flex;
  height: 2.75rem;
  width: 168.5px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  --tw-bg-opacity: 1;
  background-color: rgb(119 85 61 / var(--tw-bg-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  font-weight: 600;
  font-style: normal;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.bg-hover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 238 238 / var(--tw-bg-opacity));
}

/* For Success message after signing document */
@keyframes successAnimation {
  0% {
    transform: scale(0.9);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-tick {
  animation: successAnimation 0.5s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE;;;;GAIC,EAAE,qDAAqD;EACxD,uFAAuF;AACzF;AACA,kEAAkE;AAClE;EACE,UAAU;AACZ;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;AACnD;;AAEA,yCAAyC;AACzC;EACE;mCACiC;AACnC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,UAAU,EAAE,+BAA+B;AAC7C;;AAEA;EACE,iDAAiD,EAAE,uBAAuB;EAC1E,kBAAkB;AACpB;;AAEA;EACE;;;;;GAKC,EAAE,oCAAoC;EACvC,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,uEAAuE;AACzE;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uEAAuE;AACzE;;AAGE;EAAA,iBAAqI;EAArI,kBAAqI;EAArI,WAAqI;EAArI,gBAAqI;EAArI,sBAAqI;EAArI,iBAAqI;EAArI,sBAAqI;EAArI,yDAAqI;EAArI,kBAAqI;EAArI,yDAAqI;EAArI,eAAqI;EAArI,6CAAqI;EAArI,2DAAqI;EAArI;AAAqI;;AAIrI;EAAA,aAAwL;EAAxL,eAAwL;EAAxL,cAAwL;EAAxL,mBAAwL;EAAxL,uBAAwL;EAAxL,kBAAwL;EAAxL,iBAAwL;EAAxL,mBAAwL;EAAxL,sBAAwL;EAAxL,yDAAwL;EAAxL,kBAAwL;EAAxL,yDAAwL;EAAxL,qBAAwL;EAAxL,wBAAwL;EAAxL,eAAwL;EAAxL,gBAAwL;EAAxL,kBAAwL;EAAxL,mBAAwL;EAAxL,oBAAwL;EAAxL;AAAwL;;AAIxL;EAAA,aAAkJ;EAAlJ,eAAkJ;EAAlJ,cAAkJ;EAAlJ,mBAAkJ;EAAlJ,uBAAkJ;EAAlJ,kBAAkJ;EAAlJ,kBAAkJ;EAAlJ,uDAAkJ;EAAlJ,qBAAkJ;EAAlJ,wBAAkJ;EAAlJ,eAAkJ;EAAlJ,gBAAkJ;EAAlJ,kBAAkJ;EAAlJ,mBAAkJ;EAAlJ,oBAAkJ;EAAlJ;AAAkJ;;AAIlJ;EAAA,kBAAyB;EAAzB;AAAyB;;AAG3B,+CAA+C;AAC/C;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,4CAA4C;AAC9C","sourcesContent":["body {\n  /* background-color: #f8fafb; */\n  /* background-color: #f7f7f7; */\n  background-color: #ffff;\n}\n:root {\n  --tw-scrollbar-thumb-color: rgb(\n    208,\n    208,\n    208\n  ); /* Set your preferred color for the scrollbar thumb */\n  /* --tw-scrollbar-track-color: blue; Set your preferred color for the scrollbar track */\n}\n/* Custom scrollbar styling for Webkit browsers (Chrome, Safari) */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--tw-scrollbar-thumb-color);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: var(--tw-scrollbar-track-color);\n}\n\n/* Custom scrollbar styling for Firefox */\n.scrollbar-thin {\n  scrollbar-color: var(--tw-scrollbar-thumb-color)\n    var(--tw-scrollbar-track-color);\n}\n\n.scrollbar-thumb-gray-500 {\n  background-color: var(--tw-scrollbar-thumb-color);\n}\n\n.scrollbar-track-gray-200 {\n  background-color: var(--tw-scrollbar-track-color);\n}\n\n/* Set scrollbar width for Firefox */\n.scrollbar-thin {\n  scrollbar-width: thin;\n}\n\n/* For webkit browsers (Chrome, Safari) */\n.primary-scroll::-webkit-scrollbar {\n  width: 1px; /* Adjust the width as needed */\n}\n\n.primary-scroll::-webkit-scrollbar-thumb {\n  background-color: var(--tw-scrollbar-track-color); /* Scroll thumb color */\n  border-radius: 5px;\n}\n\n.primary-scroll::-webkit-scrollbar-track {\n  background-color: rgba(\n    29,\n    78,\n    216,\n    0.1\n  ); /* Scroll track color with opacity */\n  border-radius: 5px;\n  margin: auto;\n  max-height: 50%;\n}\n\n/* For Firefox */\n.primary-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: var(--tw-scrollbar-track-color) rgba(29, 78, 216, 0.1);\n}\n\n/* For IE and Edge */\n.primary-scroll {\n  -ms-overflow-style: none;\n  scrollbar-width: thin;\n  scrollbar-color: var(--tw-scrollbar-track-color) rgba(29, 78, 216, 0.1);\n}\n\n.stepper-cards {\n  @apply shadow-[0px_1px_9px_0px_rgba(0,0,0,0.11)] rounded-xl max-w-[895px] w-full mx-auto p-10 bg-[#FFF] border-[1px] border-[#E7ECF4];\n}\n\n.white-bg-btn {\n  @apply flex justify-center items-center text-[#77553D] text-base not-italic font-semibold leading-6 w-[168.5px] h-11 py-2.5 border rounded-[7px] border-solid border-[#969696] bg-[#fff];\n}\n\n.brown-bg-btn {\n  @apply flex justify-center items-center text-white text-base not-italic font-semibold leading-6 w-[168.5px] h-11 py-2.5 rounded-[7px] bg-[#77553d];\n}\n\n.bg-hover {\n  @apply hover:bg-[#efeeee];\n}\n\n/* For Success message after signing document */\n@keyframes successAnimation {\n  0% {\n    transform: scale(0.9);\n    opacity: 0.5;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.success-tick {\n  animation: successAnimation 0.5s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
